import { FrameWorkOrderVector } from 'orden_express/frameWork/frameWork.js';

export const SET_LIST_OF_PRODUCTS_FOR_BEGING_ORDER = 'SET_LIST_OF_PRODUCTS_FOR_BEGING_ORDER';
export const setListOfProductsForBeginingOrder = (listOfProductsForBeginingOrder) => (
  {
    type: SET_LIST_OF_PRODUCTS_FOR_BEGING_ORDER,
    listOfProductsForBeginingOrder: FrameWorkOrderVector(listOfProductsForBeginingOrder, 'name'),
  }
);
export const SET_SELECT_CLIENT = 'SET_SELECT_CLIENT';
export const setSelectClient = (selectClient) => (
  {
    type: SET_SELECT_CLIENT,
    selectClient
  }
);
export const SET_SELECT_DELIVERY_POINT = 'SET_SELECT_DELIVERY_POINT';
export const setSelectDeliveryPoint = (selectDeliveryPoint) => (
  {
    type: SET_SELECT_DELIVERY_POINT,
    selectDeliveryPoint
  }
);
export const SET_DELIVERY_POINT_LIST = 'SET_DELIVERY_POINT_LIST';
export const setDeliveryPointList = (setDeliveryPointList) => (
  {
    type: SET_DELIVERY_POINT_LIST,
    setDeliveryPointList
  }
);
export const SET_SELECT_DELIVERY_DATE = 'SET_SELECT_DELIVERY_DATE';
export const setSelectDeliveryDate = (selectDeliveryDate) => (
  {
    type: SET_SELECT_DELIVERY_DATE,
    selectDeliveryDate
  }
);

export const SET_INFORMATION_DELIVERY = 'SET_INFORMATION_DELIVERY';
export const setInformationDelivery = (informationDelivery) => (
  {
    type: SET_INFORMATION_DELIVERY,
    informationDelivery
  }
);
export const SET_MESSAGE_SAVE_ORDER_STATE = 'SET_MESSAGE_SAVE_ORDER_STATE';
export const setMessageSaveOrderState = (messageSaveOrderState) => (
  {
    type: SET_MESSAGE_SAVE_ORDER_STATE,
    messageSaveOrderState
  }
);
export const SET_MESSAGE_ORDERS_REQUESTED = 'SET_MESSAGE_ORDERS_REQUESTED';
export const setMessageOrdersRequested = (messageOrdersRequested) => (
  {
    type: SET_MESSAGE_ORDERS_REQUESTED,
    messageOrdersRequested
  }
);

export const SET_FILTER_ROUTE = 'SET_FILTER_ROUTE';
export const setFilterRoute = (filterRoute) => (
  {
    type: SET_FILTER_ROUTE,
    filterRoute
  }
);

export const SET_FILTER_DISPATCH_DATE = 'SET_FILTER_DISPATCH_DATE';
export const setFilterDispatchDate = (filterDispatchDate) => (
  {
    type: SET_FILTER_DISPATCH_DATE,
    filterDispatchDate
  }
);

export const SET_FILTER_DELIVERY_DATE = 'SET_FILTER_DELIVERY_DATE';
export const setFilterDeliveryDate = (filterDeliveryDate) => (
  {
    type: SET_FILTER_DELIVERY_DATE,
    filterDeliveryDate
  }
);

export const SET_FILTER_ORDER_TEXT = 'SET_FILTER_ORDER_TEXT';
export const setFilterOrderText = (filterOrderText) => (
  {
    type: SET_FILTER_ORDER_TEXT,
    filterOrderText
  }
);


export const SET_DATA_ORDER_FOR_SHOW_AND_EDIT = 'SET_DATA_ORDER_FOR_SHOW_AND_EDIT';
export const setDataOrderForShowAndEdit = (dataOrderForShowAndEdit) => (
  {
    type: SET_DATA_ORDER_FOR_SHOW_AND_EDIT,
    dataOrderForShowAndEdit,
  }
);

export const SET_ORDER_INFO_TO_ADD_NEW_PRODUCT_IN = 'SET_ORDER_INFO_TO_ADD_NEW_PRODUCT_IN';
export const setOrderInfoToAddNewProductIn = (dataOrderInfoToAddNewProductIn) => (
  {
    type: SET_ORDER_INFO_TO_ADD_NEW_PRODUCT_IN,
    dataOrderInfoToAddNewProductIn,
  }
);